import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import AddQuickValetModal from "./AddQuickValetModal";
import QuickValetService from "../../../../services/QuickValetService";
import Pagination from "../../../common/Pagination/Pagination";
import LeaveModal from "./LeaveModal";

const QuickValet = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [leaveModal, setLeaveModal] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const quickValetService = new QuickValetService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const search = useSelector((state) => state.auth.search);

	// useEffect(() => {
	// 	setLoading(true);
	// 	workShiftService.getList().then((res) => {
	// 		if (res?.status) {
	// 			setData(res?.data?.data?.data);
	// 			if (!!res?.data?.data?.data?.length) {
	// 				setHasData(1);
	// 			} else {
	// 				setHasData(0);
	// 			}
	// 		}
	// 		setLoading(false);
	// 	});
	// }, [shouldUpdate]);

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].quick_valet}
						</span>
					</div>
					<div className="add-department">
						{
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setItem({});
									setAddModal(true);
								}}>
								<i className="la la-plus mx-1"></i>
								{Translate[lang]?.add} {Translate[lang]?.quick_valet}
							</Button>
						}
					</div>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.vehicle_number}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.client_phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.brand_model}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.vehicle_color}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.zone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.price}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.status}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													key={index}
													item={item}
													setItem={setItem}
													setAddModal={setAddModal}
													setLeaveModal={setLeaveModal}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={quickValetService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
							/>
						</div>
					</Card>
				</Col>
			</Row>

			{addModal && (
				<AddQuickValetModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					Service={quickValetService}
				/>
			)}
			{leaveModal && (
				<LeaveModal
					item={item}
					modal={leaveModal}
					setShouldUpdate={setShouldUpdate}
					setModal={() => setLeaveModal(false)}
					Service={quickValetService}
				/>
			)}
		</div>
	);
};

export default QuickValet;
